import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { KFormSelect } from '@kwixeo/form-vue'
import { BFormRow, BCol, BFormGroup } from 'bootstrap-vue'

@Component({
  components: {
    KFormSelect,
    BFormRow, BCol, BFormGroup
  }
})
export default class ProductVariationSelect extends Vue {
  @Prop({ default: null }) value!: KwixeoCatalog.ProductVariation|null
  @Prop({ required: true }) product!: KwixeoCatalog.Product
  @Prop({ default: 'sm' }) size!: string
  @Prop({ default: null }) validationName!: string|null

  private variationLevel1: KwixeoCatalog.VariationValue|null = null
  private variationLevel2: KwixeoCatalog.VariationValue|null = null
  private variationLevel3: KwixeoCatalog.VariationValue|null = null

  // Return url to get values for level 1
  get variationLevel1Ajax (): string {
    return '/catalog/product/' + this.product.id + '/levels'
  }

  // Return url to get values for level 2
  get variationLevel2Ajax (): string {
    return '/catalog/product/' + this.product.id +
      '/levels?level1=' + this.variationLevel1?.id
  }

  // Return url to get values for level 3
  get variationLevel3Ajax (): string {
    return '/catalog/product/' + this.product.id +
      '/levels?level1=' + this.variationLevel1?.id + '&level2=' + this.variationLevel2?.id
  }

  // Actions when level1 is changed
  private level1Change (): void {
    this.variationLevel2 = null
    this.variationLevel3 = null

    this.selectVariation(this.product.variations_length === 1)
  }

  // Actions when level2 is changed
  private level2Change (): void {
    this.variationLevel3 = null
    this.selectVariation(this.product.variations_length === 2)
  }

  // Actions when level3 is changed
  private level3Change (): void {
    this.selectVariation(true)
  }

  // Function call when a variation is selected
  private selectVariation (select: boolean): void {
    let variation: KwixeoCatalog.ProductVariation|null|undefined = null
    if (select) {
      let level: KwixeoCatalog.VariationValue
      switch (this.product.variations_length) {
        case 1:
          level = this.variationLevel1 as KwixeoCatalog.VariationValue
          variation = level.variations?.find(variation => {
            return variation.level1_id === this.variationLevel1?.id
          })
          break
        case 2:
          level = this.variationLevel2 as KwixeoCatalog.VariationValue
          variation = level.variations?.find(variation => {
            return variation.level1_id === this.variationLevel1?.id
              && variation.level2_id === this.variationLevel2?.id
          })
          break
        case 3:
          level = this.variationLevel3 as KwixeoCatalog.VariationValue
          variation = level.variations?.find(variation => {
            return variation.level1_id === this.variationLevel1?.id
              && variation.level2_id === this.variationLevel2?.id
              && variation.level3_id === this.variationLevel3?.id
          })
          break
      }
    }
    this.$emit('input', variation)

    if (!variation) {
      return
    }
    this.$emit('selected', variation)
  }

  // Watch the product variation to attribute local variation levels
  @Watch('value', { immediate: true })
  private watchProduct (value: KwixeoCatalog.ProductVariation|null): void {
    if (!value) {
      return
    }
    this.variationLevel1 = value.level1
    this.variationLevel2 = value.level2
    this.variationLevel3 = value.level3
  }

  // Watch if level1 is changed
  @Watch('variationLevel1')
  private watchLevel1 (variation: KwixeoCatalog.VariationValue|null): void {
    if (!variation && this.product.variations_length === 1) {
      this.$emit('unselected')
    }
  }

  // Watch if level2 is changed
  @Watch('variationLevel2')
  private watchLevel2 (variation: KwixeoCatalog.VariationValue|null): void {
    if (!variation && this.product.variations_length === 2) {
      this.$emit('unselected')
    }
  }

  // Watch if level3 is changed
  @Watch('variationLevel3')
  private watchLevel3 (variation: KwixeoCatalog.VariationValue|null): void {
    if (!variation && this.product.variations_length === 3) {
      this.$emit('unselected')
    }
  }
}
